import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

const ComingSoonLayerOne = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = `${API_BASE_URL}/api/getInTouchGisLab/create-get-in-touch-gis-lab`;
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      const data = await response.json();
      
      if (data.success) {
        toast.success("Your message has been sent successfully! Our team will reach out to you soon.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
        setFormData({ name: "", email: "", phoneNumber: "", message: "" });
      } else {
        toast.error('Something went wrong. Please try again.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Error submitting form. Please check your connection and try again.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  return (
    <div className="d-flex align-items-center" >
      <ToastContainer />
      <div className="container" >
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0 rounded-3 overflow-hidden">
              <div className="row g-0">
                <div className="col-lg-7">
                  <div className="card-body p-5">
                    <h4 className="fw-bold text-success mb-40">Get In Touch With GIS Lab for Queries/ Recommendations.</h4>
                    <p className="text-muted mb-4">
                      Have questions or need assistance? We'd love to hear from you. 
                      Send us a message and we'll respond as soon as possible.
                    </p>
                    
                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        className="form-control py-3"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        onKeyPress={(e) => {
                          // Allow only letters and spaces
                          if (!/[a-zA-Z\s]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter your name"
                        required
                      />
                      
                      <div className="mb-3">
                        <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                        <input
                          type="tel"
                          className="form-control py-3"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            // Allow only numbers
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          placeholder="Enter your phone number"
                          required
                        />
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email Address</label>
                        <input
                          type="email"
                          className="form-control py-3"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter your email"
                          required
                        />
                      </div>
                      
                      <div className="mb-4">
                        <label htmlFor="message" className="form-label">Your Message</label>
                        <textarea
                          className="form-control"
                          id="message"
                          name="message"
                          rows="4"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="How can we help you?"
                          required
                        ></textarea>
                      </div>
                      
                      <button type="submit" className="btn btn-success btn-lg w-100 py-3 mt-20">
                        Send Message
                      </button>
                    </form>
                  </div>
                </div>
                
                <div className="col-lg-5 d-none d-lg-flex bg-success-200 text-white">
                  <div className="card-body p-1.5 d-flex flex-column justify-content-center">
                    <h4 className="fw-bold mb-4">Contact Information</h4>
                    <p className="mb-4">
                      Reach out to us through any of these channels. Our team is ready to assist you.
                    </p>
                    
                    <div className="d-flex flex-column gap-4 mt-4">
                      <div className="d-flex align-items-center">
                        <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                          <i className="ri-mail-fill text-warning-500 fs-5"></i>
                        </div>
                        <div>
                          <h6 className="mb-0">Email Us</h6>
                          <p className="mb-0">devteam@fwf.punjab.gov.pk</p>
                        </div>
                      </div>
                      
                      <div className="d-flex align-items-center">
                        <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                          <i className="ri-phone-fill fs-5"></i>
                        </div>
                        <div>
                          <h6 className="mb-0">Call Us</h6>
                          <p className="mb-0">+92 337 9926560</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                          <i className="ri-whatsapp-fill text-success-500 fs-5"></i>
                        </div>
                        <div>
                          <h6 className="mb-0">Whatsapp</h6>
                          <p className="mb-0">+92 337 9926560</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                          <i className="ri-map-pin-fill text-danger-500 fs-5"></i>
                        </div>
                        <div>
                          <h6 className="mb-0">Address</h6>
                          <p className="mb-0">GIS Lab, 108-Ravi Road, Lahore, Punjab, Pakistan</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mt-5">
                      <h5 className="mb-3">Follow Us</h5>
                      <div className="social-icons-container">
                        <div className="d-flex gap-3">
                          <a href="https://www.facebook.com/fwfpunjab" target="_blank" rel="noreferrer" className="facebook-icon" aria-label="Facebook">
                            <i className="ri-facebook-fill"></i>
                          </a>
                          <a href="https://x.com/fwfpunjabpk" target="_blank" rel="noreferrer" className="twitter-icon" aria-label="Twitter">
                            <i className="ri-twitter-fill"></i>
                          </a>
                          <a href="https://www.tiktok.com/@fwfpunjab" target="_blank" rel="noreferrer" className="tiktok-icon" aria-label="TikTok">
                            <i className="ri-tiktok-fill"></i>
                          </a>
                          <a href="https://www.instagram.com/fwfpunjab" target="_blank" rel="noreferrer" className="instagram-icon" aria-label="Instagram">
                            <i className="ri-instagram-fill"></i>
                          </a>
                          <a href="https://youtube.com/@forestryandwildlifeofficial" target="_blank" rel="noreferrer" className="youtube-icon" aria-label="YouTube">
                            <i className="ri-youtube-fill"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonLayerOne;